import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (config?: DynamicObject): Promise<AxiosResponse> => {
    const path = '/account/my-account/summary/v1'
    return Api.getInstance(false,false,process.env.REACT_APP_API_SUB_URL).request.get(`${path}`, path)
}
